import { useUser } from "../../context/user-context/user-context";
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';


export const RequireAuth = ({children}) => {
    const thisСustomer = useUser();

    const {customer} = thisСustomer;

    const location = useLocation();

    const navigate = useNavigate();

    useEffect(() => {
        if (customer.phone === null) {
           return  navigate('/signin', { state: {from: location}});
        }
    }, [customer]);

    return children;
}